import Swiper, { Navigation, Pagination } from 'swiper'
Swiper.use([ Navigation, Pagination ])

class InstrumentSlider {
  
  constructor (el) {
    this.el = el
    this.sliderContainer = el.querySelector('.js-instrument-slider-container')
    this.slider = null
    this.isMobile = false
    this.options = {
      spaceBetween: 24,
      slidesPerView: 3,
      simulateTouch: true,
      observeParents: true,
      observer: true,
      breakpoints: {
        0: {
          spaceBetween: 16,
          slidesPerView: 1
        },
        768: {
          spaceBetween: 16,
          slidesPerView: 2
        }
      },
      navigation: {
        prevEl: '.js-slider-control-prev',
        nextEl: '.js-slider-control-next'
      },
      pagination: {
        el: '.js-slider-control-pagination',
        clickable: true
      }
    }

    this.initDefault()
  }

  initDefault () {
    this.initEvents()
    this.onResize()
  }

  initEvents () {
    window.addEventListener('resize', e => this.onResize())
  }

  onResize () {
    this.checkMobile()
    if ( this.isMobile && !this.slider ) {
      if ( this.slider ) return;
      this.initSlider()
    } else if ( !this.isMobile && this.slider ) {
      if ( !this.slider ) return;
      this.slider.destroy()
      this.slider = null
    }
  }

  checkMobile () {
    window.innerWidth > 1023 ? this.isMobile = false : this.isMobile = true
  }

  initSlider () {
    this.slider = new Swiper( this.sliderContainer, this.options)
  }

}

document.addEventListener('DOMContentLoaded', e => {
  const el = document.querySelector('.js-instrument-slider')
  if ( el ) {
    new InstrumentSlider(el)
  }
})